import React, { useEffect, useRef } from 'react';
import { Popover, PopoverTrigger, PopoverContent, Box } from '@spothero/ui';
import { useDispatch, useSelector } from 'react-redux';
import { toggleLoyaltyProgram } from 'store/filters/filters-actions';
import { FilterCheckboxBase } from '../../../filter-bases';
import { loadSpotsTransientV2 } from 'store/spots/spots-actions-v2';
import { SEARCH_TRACKING_ACTIONS } from 'utils/search-tracking';
import StorageUtils from '@spothero/utils/storage';
import { LOYALTY_PROGRAM_FILTER_VALUES } from 'store/filters/loyalty-filter-utils';
import usePrevious from 'hooks/use-previous';
import trackProductListFiltered from 'segment/events/product-list-filtered';
import { StorageDurations, StorageKeys, StorageTypes, } from 'common/constants/storageKeys';
import { useSortBy } from 'hooks/use-sort-by';
import { setSearchLoyaltyProgramPopoverVisible } from 'store/search/search-actions';
import { useTooltips, TOOLTIPS } from 'pages/search/hooks/use-tooltips';
import useMobileBreakPoint from 'hooks/use-mobile-breakpoint';
export default function FilterLoyaltyProgram() {
    const dispatch = useDispatch();
    const sortBy = useSortBy();
    const loyaltyProgramTooltip = useTooltips(TOOLTIPS.loyalty_program_popover);
    const user = useSelector((s) => s.user.data);
    const loyaltyProgramSelectedValue = useSelector((s) => s.filters.loyaltyProgram);
    const storeState = useSelector((state) => state);
    const searchData = useSelector((s) => s.search.data);
    const isMobile = useMobileBreakPoint();
    const searchType = searchData?.searchType || '';
    const loyaltyProgramIsSelected = loyaltyProgramSelectedValue === LOYALTY_PROGRAM_FILTER_VALUES.ON;
    // If we turned the filter off because it displayed no spots, we want to explain that to the user
    const loyaltyProgramAutoOff = loyaltyProgramSelectedValue ===
        LOYALTY_PROGRAM_FILTER_VALUES.AUTOMATIC_OFF;
    const justClickedRef = useRef(false);
    const handleClick = () => {
        justClickedRef.current = true;
        dispatch(toggleLoyaltyProgram(loyaltyProgramIsSelected
            ? LOYALTY_PROGRAM_FILTER_VALUES.USER_OFF
            : LOYALTY_PROGRAM_FILTER_VALUES.ON));
        dispatch(loadSpotsTransientV2({
            searchTrackingAction: SEARCH_TRACKING_ACTIONS.LOYALTY_PROGRAM_FILTER_CHANGED,
            locationContext: searchType,
            sortBy,
        }));
    };
    useEffect(() => {
        // ensure click caused the change to the store and make sure store changed before calling tracking
        if (justClickedRef.current) {
            trackProductListFiltered({
                state: storeState,
                filters: {
                    ...storeState.filters,
                },
            });
            justClickedRef.current = false;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [storeState.filters.loyaltyProgram]);
    const seenLoyaltyProgramInfo = StorageUtils.get(StorageKeys.SEEN_LOYALTY_PROGRAM_INFO_COOKIE, StorageTypes.COOKIE);
    const prevLoyaltyProgramAutoOff = usePrevious(loyaltyProgramAutoOff);
    useEffect(() => {
        if (!prevLoyaltyProgramAutoOff && loyaltyProgramAutoOff) {
            dispatch(setSearchLoyaltyProgramPopoverVisible(true));
        }
    }, [loyaltyProgramAutoOff, prevLoyaltyProgramAutoOff, dispatch]);
    useEffect(() => {
        if (user?.operatorLoyaltyProgram &&
            loyaltyProgramIsSelected &&
            !seenLoyaltyProgramInfo) {
            dispatch(setSearchLoyaltyProgramPopoverVisible(true));
            StorageUtils.set(StorageKeys.SEEN_LOYALTY_PROGRAM_INFO_COOKIE, true, StorageTypes.COOKIE, StorageDurations.YEAR);
        }
    }, [
        user?.operatorLoyaltyProgram,
        seenLoyaltyProgramInfo,
        loyaltyProgramIsSelected,
        dispatch,
    ]);
    if (!user || !user?.operatorLoyaltyProgram) {
        return null;
    }
    const program = user.operatorLoyaltyProgram;
    const _onHandleClose = loyaltyProgramTooltip.handleClose;
    return (<Box as="span" sx={{
            '.chakra-popover__popper': {
                zIndex: '1',
            },
        }}>
            <Popover returnFocusOnClose={false} isOpen={!isMobile && loyaltyProgramTooltip.isVisible} onClose={_onHandleClose} placement="bottom" variant="dark">
                <PopoverTrigger>
                    <FilterCheckboxBase testid={`QuickFilters-loyalty-program-${program.title}`} onClick={handleClick} isActive={loyaltyProgramIsSelected}>
                        {program.title}
                    </FilterCheckboxBase>
                </PopoverTrigger>
                <PopoverContent marginLeft={4} paddingRight={6}>
                    {loyaltyProgramTooltip.text}
                </PopoverContent>
            </Popover>
        </Box>);
}
